<template>
  <x-page title="申请发货" :loading="loading">
    <template v-if="!loading">
      <!-- 收货地址 -->
      <div
        v-track="{
          name: '申请发货-选择地址',
          id: '108064aa-34f8-42bc-a6c6-0136c26070a4',
        }"
        :class="_.address"
      >
        <x-card
          v-if="!address.id"
          :class="_.add"
          @click.native="handleChooseAddressClick"
        >
          <img :src="require('./images/地址.png')" :class="_.icon" />
          <div :class="_.text">请添加收货地址</div>
        </x-card>
        <x-card
          v-else
          :class="_.content"
          @click.native="handleChooseAddressClick"
        >
          <img :src="require('./images/已选择地址.png')" :class="_.icon" />
          <div :class="_.left">
            <div :class="_.hd">
              <div :class="_.user">{{ address.receiver }}</div>
              <div :class="_.phone">{{ address.phoneNo }}</div>
              <div v-if="address.defaultFlag" :class="_.tag">默认</div>
            </div>
            <div :class="_.bd">
              {{
                `${address.province}${address.city}${address.county}${address.detail}`
              }}
            </div>
          </div>
          <van-icon name="arrow" :class="_.arrow" />
        </x-card>
      </div>

      <!-- 商品列表 -->
      <x-card
        v-for="merchant in preOrderData.orderInfo"
        :key="merchant.merchantId"
        :class="_.merchant"
      >
        <div :class="[_.hd, _._hairlineBottom]">
          <img
            :src="merchant.merchantPic || require('./images/店铺.png')"
            :class="_.logo"
          />
          <div :class="_.name">{{ merchant.merchantName }}</div>
        </div>
        <div :class="_.bd">
          <div
            v-for="goods in merchant.commodityInfo"
            :key="goods.commodityId"
            :class="_.goods"
          >
            <van-image :src="goods.commodityPic" :class="_.cover" fit="cover" />
            <div :class="_.main">
              <div :class="_.top">
                <div :class="_.content">
                  <div :class="[_.name, _._ellipsis2]">
                    {{ goods.commodityName }}
                  </div>
                  <div :class="_.desc">{{ goods.skuDesc }}</div>
                </div>
                <div :class="_.info">
                  <div :class="_.price">￥{{ goods.unitPrice }}</div>
                  <div :class="_.amount">x{{ goods.count }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div :class="_.ft">
          <div :class="_.item">
            <div :class="_.label">配送</div>
            <div :class="_.value">快递配送</div>
            <div :class="_.extra">包邮</div>
          </div>
          <div :class="_.item">
            <div :class="_.label">备注</div>
            <div :class="_.value">
              <input
                v-model="orderData[merchant.orderId].remark"
                v-fix-keyboard
                type="text"
                :class="_.input"
                placeholder="选填，给商家留言"
                maxlength="20"
              />
            </div>
          </div>
        </div>
        <div :class="_.ex">
          <div :class="_.count">共 {{ merchant.totalQuantity }} 件</div>
          <div :class="_.label">小计</div>
          <div :class="_.unit">¥</div>
          <div :class="_.price">
            {{ merchant.totalAmount }}
          </div>
        </div>
      </x-card>

      <!-- 概况 -->
      <x-card :class="_.brief">
        <div :class="_.item">
          <div :class="_.label">商品总额</div>
          <div :class="_.value">
            ¥{{ preOrderData.orderInfo[0].totalAmount }}
          </div>
        </div>
        <div :class="_.item">
          <div :class="_.label">运费</div>
          <div :class="_.value">¥0</div>
        </div>
      </x-card>

      <!-- 操作 -->
      <div :class="_.actions">
        <div :class="_.ft">
          <div :class="_.amount"></div>
          <div :class="_.grow" />
          <x-button
            v-track="{
              name: '申请发货-立即发货',
              id: '56659ecb-935f-4054-ba88-6ad9df54d561',
            }"
            small
            :class="_.button"
            @click="handleDeliveryClick"
          >
            立即发货
          </x-button>
        </div>
      </div>
      <div :class="_.placeholder" />
    </template>
  </x-page>
</template>

<script>
  import Vue from 'vue'
  import { AddressBridge } from '@/views/address/bridge'
  import { apiBlindBoxOrderDeliver, apiBlindBoxOrderPreDeliver } from '@/api'
  import { boxBus } from './bus'
  import { globalModel } from '@/model'
  import { mapQuery, prepareData, submit, Track } from '@/utils'
  import { navigateBackOrTo } from '@/router'
  import { values } from 'vtils'

  export default Vue.extend({
    mixins: [
      mapQuery({
        orderId: 'orderId',
      }),
      Track.provideMark(() => ({
        page: '申请发货',
      })),
    ],

    data: () => ({
      // 页面级加载状态
      loading: true,

      // 预下单数据
      preOrderData: {},

      // 下单数据
      orderData: {},

      // 收货地址
      address: {},
    }),

    watch: {
      // 计算订单提交数据
      preOrderData: {
        immediate: true,
        handler(preOrderData) {
          this.orderData = preOrderData.orderInfo.reduce((res, merchant) => {
            res[merchant.orderId] = {
              orderId: merchant.orderId,
              remark: '',
            }
            return res
          }, {})
        },
      },
    },

    created() {
      this.prepareData()
    },

    methods: {
      // 准备数据
      async prepareData() {
        const { address, preOrderData } = await prepareData({
          address: AddressBridge.getDefaultAddress().then(
            res => res || {},
            () => ({}),
          ),
          preOrderData: apiBlindBoxOrderPreDeliver({
            id: this.orderId,
          }),
        })
        this.address = address
        this.preOrderData = preOrderData
        this.loading = false
      },

      // 点击选择地址
      async handleChooseAddressClick() {
        const address = await AddressBridge.chooseAddress()
        if (address && address.id) {
          this.address = address
        }
      },

      // 点击立即发货按钮
      async handleDeliveryClick() {
        await submit(async $ => {
          if (!this.address.id) {
            return $.fail('请先添加收货地址')
          }
          await $.start()
          await apiBlindBoxOrderDeliver({
            preOrderId: this.preOrderData.preOrderId,
            consigneeName: this.address.receiver,
            consigneeTel: this.address.phoneNo,
            consigneeAddress: {
              province: this.address.province,
              city: this.address.city,
              area: this.address.county,
              areaCode: this.address.districtCode,
              detail: this.address.detail,
              name: this.address.receiver,
              phoneNo: this.address.phoneNo,
            },
            tradeOrderInfo: values(this.orderData),
            couponId: undefined,
            discountAmount: 0,
            payType: globalModel.state.payType,
            openId: globalModel.state.openid,
          })
          boxBus.emit('shouldRefreshOrderList')
          navigateBackOrTo('BoxOrderList')
        })
      },
    },
  })
</script>

<style lang="scss" module>
  .address {
    .add {
      display: flex;
      align-items: center;
      justify-content: center;

      .icon {
        width: 19px;
        height: 19px;
      }

      .text {
        margin-left: 2px;
        font-size: 14px;
        color: #222222;
      }

      &:active {
        opacity: 0.8;
      }
    }

    .content {
      display: flex;
      align-items: center;

      .icon {
        flex-shrink: 0;
        width: 36px;
        height: 36px;
      }

      .left {
        margin-left: 12px;
        flex-grow: 1;

        .hd {
          display: flex;
          align-items: center;

          .user {
            font-size: 14px;
            color: #222222;
            line-height: 20px;
          }

          .phone {
            margin-left: 8px;
            font-size: 14px;
            color: #888888;
            line-height: 20px;
          }

          .tag {
            margin-left: 8px;
            background: #fff2f1;
            border-radius: 1000px;
            font-size: 10px;
            color: #ff111c;
            padding: 2px 5px;
            line-height: 1;
          }
        }

        .bd {
          margin-top: 4px;
          font-size: 12px;
          color: #222222;
          line-height: 16px;
        }
      }

      .arrow {
        flex-shrink: 0;
        font-size: 14px;
        color: #bebebe;
      }

      &:active {
        opacity: 0.8;
      }
    }
  }

  .merchant {
    .hd {
      display: flex;
      align-items: center;
      padding-bottom: 12px;

      .logo {
        width: 16px;
        height: 16px;
        flex-shrink: 0;
        user-select: none;
        -webkit-touch-callout: none;
      }

      .name {
        margin-left: 6px;
        font-size: 14px;
        color: #222222;
      }
    }

    .bd {
      .goods {
        margin-top: 14px;
        display: flex;

        .cover {
          flex-shrink: 0;
          width: 85px;
          height: 85px;
          border-radius: 8px;
          overflow: hidden;
        }

        .main {
          margin-left: 12px;
          flex-grow: 1;

          .top {
            display: flex;

            .content {
              flex-grow: 1;

              .name {
                font-size: 14px;
                color: #222222;
                line-height: 20px;
              }

              .desc {
                display: inline-block;
                margin-top: 4px;
                background: #f5f6f8;
                border-radius: 1000px;
                font-size: 10px;
                color: #888888;
                padding: 3px 6px;
              }
            }

            .info {
              margin-left: 20px;
              flex-shrink: 0;

              .price {
                font-size: 12px;
                color: #1d1d1c;
                text-align: right;
              }

              .amount {
                margin-top: 5px;
                font-size: 12px;
                color: #888888;
                text-align: right;
              }
            }
          }

          .tips {
            margin-top: 4px;
            font-size: 10px;
            color: #ff111c;
            line-height: 16px;
          }
        }
      }
    }

    .ft {
      .item {
        margin-top: 12px;
        display: flex;
        align-items: center;

        .label {
          flex-shrink: 0;
          width: 85px;
          text-align: right;
          font-size: 12px;
          color: #222222;
        }

        .value {
          margin-left: 12px;
          flex-grow: 1;
          font-size: 12px;
          color: #888888;

          .input {
            width: 100%;
            appearance: none;
            outline: none;
            box-shadow: none;
            border: none;
            border-radius: 0;

            &::placeholder {
              color: #bebebe;
            }
          }
        }

        .extra {
          flex-shrink: 0;
          font-size: 12px;
          color: #222222;
        }
      }
    }

    .ex {
      margin-top: 20px;
      display: flex;
      align-items: center;
      justify-content: flex-end;

      .count {
        font-size: 12px;
        color: #989898;
        line-height: 18px;
      }

      .label {
        font-size: 12px;
        color: #222222;
        line-height: 18px;
        margin: 0 4px;
      }

      .unit {
        font-size: 10px;
        color: #ff111c;
        line-height: 16px;
        margin-right: 2px;
      }

      .price {
        font-size: 14px;
        color: #ff111c;
        line-height: 18px;
      }
    }
  }

  .brief {
    .item {
      display: flex;
      align-items: center;

      + .item {
        margin-top: 12px;
      }

      .label {
        flex-shrink: 0;
        font-size: 14px;
        color: #222222;
      }

      .value {
        flex-grow: 1;
        font-size: 14px;
        color: #222222;
        text-align: right;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        line-height: 1;

        .gray {
          color: #999;
        }

        .red {
          color: #ff111c;
        }

        .arrow {
          margin-left: 4px;
          flex-shrink: 0;
          font-size: 14px;
          color: #222222;
        }
      }
    }
  }

  .actions {
    position: fixed;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: white;
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);

    .ft {
      background-color: white;
      display: flex;
      align-items: center;
      padding: 8px 12px;

      .amount {
        flex-shrink: 0;
        font-size: 14px;
        color: #888888;
      }

      .total {
        flex-shrink: 0;
        font-size: 14px;
        font-weight: bold;
        color: #ff111c;
      }

      .grow {
        flex-grow: 1;
      }

      .button {
        margin-left: 8px;
        flex-shrink: 0;
      }
    }

    + .placeholder {
      height: 120px;
    }
  }
</style>
